import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './message.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { UnusualMessage } from "model/system/unusual-message.model";

export interface UnusualMessageDetailsProps extends DetailsStateAndDispatchProps<UnusualMessage>,
  RouteComponentProps, StateProps, DispatchProps {
}
const UnusualMessageDetails: FC<UnusualMessageDetailsProps> = (props) => {
  return (
    <DetailsPage<UnusualMessage>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<UnusualMessage>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ unusualMessage }: RootState) => ({
  entity: unusualMessage.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(UnusualMessageDetails);
